module.exports = __webpack_public_path__ + "img/1507805564.8900f07f.jpg";